/**
 *Created by jmmartinez on 3/8/18
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1  02/02/2021 Añadida función transformarDatosLista
 **/

import React from 'react'
import { ResponsiveBar } from '@nivo/bar'
import PropTypes from 'prop-types';
import {floatToFloat2Decimales, stringComasToFloat} from '../ej2/utils/NumberUtils'



class BarrasResponsive extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            datos: props.datos,
        }
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.datos !== prevState.datos) {
            newState.datos = nextProps.datos;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }



    transformarDatos= () => {
        const {datos} = this.state;
        const {campoNombre, camposValor, camposValorLeyenda} = this.props;
        if (datos && datos.rows) {
            let datosGrafica = datos.rows.reduce((datosReduced, row) => {
                if (!row.esPie) {
                    let elemento = {
                        nombre: row.propiedades[campoNombre.toUpperCase()],

                    }
                    let numCampos= camposValor.length;
                    for (let i=0; i < numCampos; i++){
                       let campo= camposValor[i];
                       let campoLeyenda= camposValorLeyenda[i];
                        elemento[campoLeyenda] =  stringComasToFloat(row.propiedades[campo.toUpperCase()]);
                    }
                    datosReduced.push(elemento);
                }
                return datosReduced;
            }, []);

            console.log("DATOS GRAFICA");
            console.log(datosGrafica);
            return datosGrafica;
        }
        else{
            return [];
        }
    }

    transformarDatosLista= () => {
        const {datos} = this.state;
        const {campoNombre, camposValor,camposValorLeyenda} = this.props;
        if (datos) {
            let datosGrafica = datos.reduce((datosReduced, row) => {
                let elemento = {
                    nombre: row[campoNombre],
                }
                let numCampos= camposValor.length;
                for (let i=0; i < numCampos; i++){
                    let campo= camposValor[i];
                    let campoLeyenda= camposValorLeyenda[i];
                    let valor= row[campo];
                    elemento[campoLeyenda] =  valor;
                }
                datosReduced.push(elemento);
                return datosReduced;
            }, []);
            return datosGrafica;
        }
        else{
            return [];
        }
    }

    render() {
        const {datos} =  this.state;
        const {camposValorLeyenda, tituloEjeX, tituloEjeY, apilado, orientacion} = this.props;
        console.log("BARRAS RENDER");
        console.log(datos);

        let groupMode= apilado ?  null : "grouped";
        let layout= orientacion ? orientacion : "vertical";
        return (
                <ResponsiveBar
                    data={this.transformarDatosLista()}
                    keys={camposValorLeyenda}
                    indexBy="nombre"

                    groupMode= {groupMode}
                    layout= {layout}


                    //margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                    margin={{ top: 20, right: 120, bottom: 40, left: 60 }}
                    padding={0.3}
                    colors={{ scheme: 'nivo' }}

                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: tituloEjeX,
                        legendPosition: 'middle',
                        legendOffset: 32
                    }}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: tituloEjeY,
                        legendPosition: 'middle',
                        legendOffset: -40
                    }}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    legends={[
                        {
                            dataFrom: 'keys',
                            anchor: 'bottom-right',
                            direction: 'column',
                            justify: false,
                            translateX: 120,
                            translateY: 0,
                            itemsSpacing: 2,
                            itemWidth: 100,
                            itemHeight: 20,
                            itemDirection: 'left-to-right',
                            itemOpacity: 0.85,
                            symbolSize: 20,
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemOpacity: 1
                                    }
                                }
                            ]
                        }
                    ]}
                    animate={true}
                    motionStiffness={90}
                    motionDamping={15}
                />
        );
    }
}


BarrasResponsive.propTypes = {
    datos: PropTypes.array,
    campoNombre: PropTypes.string,
    camposValorLeyenda: PropTypes.array,
    tituloEjeX: PropTypes.string,
    tituloEjeY: PropTypes.string,
    mostrarLeyenda: PropTypes.bool,
    apilado: PropTypes.bool,
    orientacion: PropTypes.string, //"horizontal, vertical"
}

export default BarrasResponsive

